import {
  Box,
  Heading,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import * as _ from 'lodash';
import React from 'react';

import {
  CreditAgreement,
  getBooleanSymbol,
} from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/common';

type BaseOrganizationEntityProps = {
  children: React.ReactNode;
  party: CreditAgreement.DomainEntity.Items.PartyEntity;
};
export const BaseOrganizationEntity = ({
  party,
  children,
}: BaseOrganizationEntityProps) => {
  const { entity, customerType, section, _isWrittenIn_ } = party;

  return (
    <Box width="100%">
      <Heading size="md" mb="20px">
        {entity.name}
      </Heading>
      <Text fontSize="16px" mb="10px" fontWeight="bold">
        Metadata
      </Text>
      <Box display="flex" mb="20px" width="100%">
        <Table borderWidth="1px">
          <Thead>
            <Tr>
              <Th>Name</Th>
              <Th>Customer Type</Th>
              <Th>Section</Th>
              {!_.isNil(_isWrittenIn_) && <Th>Is Written In</Th>}
              <Th>{React.Children.toArray(children)[0]}</Th>
            </Tr>
          </Thead>
          <Tbody>
            <Tr>
              <Td>{entity.name}</Td>
              <Td>{customerType}</Td>
              <Td>{section}</Td>
              {!_.isNil(_isWrittenIn_) && (
                <Td>{getBooleanSymbol(_isWrittenIn_)}</Td>
              )}
              <Td>{React.Children.toArray(children)[1]}</Td>
            </Tr>
          </Tbody>
        </Table>
      </Box>
    </Box>
  );
};
